import { render, staticRenderFns } from "./PlayerEmbed.vue?vue&type=template&id=c6b7050c&scoped=true"
import script from "./PlayerEmbed.vue?vue&type=script&lang=js"
export * from "./PlayerEmbed.vue?vue&type=script&lang=js"
import style0 from "./PlayerEmbed.vue?vue&type=style&index=0&id=c6b7050c&prod&scoped=true&lang=css"
import style1 from "./PlayerEmbed.vue?vue&type=style&index=1&id=c6b7050c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b7050c",
  null
  
)

export default component.exports